export default "__VITE_ASSET__GW4vL8Cd__"